<template>
    <span>{{ title }}</span>
</template>
<script>
    export default {
        props: {
            value: { default: '' }
        },
        data: function () {
            return {
                title: this.value
            }
        },
        created() {
            this.$eventHub.$on('updatePageTitle', this.update);
        },
        methods: {
            update (title) {
                this.title = title;
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('updatePageTitle', this.update);
        }
    }
</script>